export default __webpack_public_path__ + "static/media/img_14.d97c3f1c.JPG";